module.exports = __webpack_public_path__ + "img/search-desktop.799b38c2.svg";